import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { AuthService } from '@services/api/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard  {

  constructor(private router: Router,
    private authService:AuthService) {
  }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    
      var profile = this.authService.profile;

      if(profile){
        this.router.navigate(["auth"]);
        return false;
      }
  
      return true;
  }
  
}
